import { ReactElement } from 'react';
import DemoVideo from '../../components/DemoVideo/DemoVideo';
import './styles.css';
import { getMediaUrl, MediaUrls } from '../../utils';
import downloadOnAppStore from '../../assets/downloadOnAppStore.svg';

export default function ShopAdviser(): ReactElement {
  return (
    <div style={{ textAlign: 'left' }}>
      <div style={{ textAlign: 'left' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: '3rem',
          }}
        >
          <img
            src={getMediaUrl(MediaUrls.ShopAdviserLogo)}
            alt="Shop Adviser Logo"
            style={{ objectFit: 'contain', width: '5rem' }}
          ></img>

          <a
            href="https://apps.apple.com/app/id1598823402"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={downloadOnAppStore}
              alt="Download on the App Store"
              style={{ objectFit: 'contain' }}
            ></img>
          </a>
        </div>
        <div style={{ textAlign: 'center', fontSize: 20, flex: 1 }}>
          Shop Adviser
        </div>
      </div>

      <hr></hr>
      <div>
        <p>
          Shop Adviser is a React-Native IOS application. It was built as a
          christmas present to my family. We all love to cook and we all needed
          a list. Most lists are overcomplicated these days. Data lives in the
          cloud, and buffers when you don't have service deep into Woodman's, so
          this was designed to be a simple, elegant and convenient grocery list
          app. This serverless approach means it costs nothing to maintain.
        </p>
        <p>
          <i>*Jason is actively maintaining and improving this project*</i>
        </p>
        <br />
        <b>{'Programming language: '}</b>
        Typescript
        <div></div>
        <b>{'Programming environment: '}</b>
        React-Native
      </div>
      <br />
      <div
        style={{
          display: 'flex',
          marginBottom: 10,
        }}
      >
        <div
          style={{
            flex: 1,
            border: '1px solid grey',
            borderRightWidth: 0.5,
            padding: 10,
          }}
        >
          <b>Skills gained</b>
          <ul>
            <li>Efficient animations</li>
            <li>Local SQL Lite database</li>
            <li>Version tracking and local data migration</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
